import React from 'react';
import { ArrowRightIcon, BadgeCheckIcon } from 'lucide-react';
import { SmartLink } from '../SmartLink';
type PricingTeaserProps = {
  text: string;
  linkLabel: string;
  href: string;
};
export function PricingTeaser({
  text,
  linkLabel,
  href
}: PricingTeaserProps) {
  return <section className="w-full bg-white pb-20" aria-label="Pricing" data-id="element-1154" data-mp="2d8icnk3yhoh9">
      <div className="mx-auto max-w-shell px-6" data-id="element-1155" data-mp="2d7783i2oscp3">
        <div className="flex flex-col gap-4 rounded-[14px] bg-brand-soft px-6 py-5 sm:flex-row sm:items-center sm:justify-between sm:px-8" data-id="element-1156" data-mp="2qzdkqu6ms1js">
          <p className="flex items-center gap-3 text-[16px] font-medium text-ink" data-id="element-1157" data-mp="2mxs6b4eg7f7h">
            <BadgeCheckIcon className="h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-1158" data-mp="30wrt06iehk10" />
            {text}
          </p>
          <SmartLink href={href === '#' ? '/pricing' : href} className="inline-flex shrink-0 items-center gap-1.5 text-[15px] font-semibold text-brand transition-colors duration-150 ease-out hover:text-brand-hover" data-id="element-1159" data-mp="2vzswjhb9l0zn">
            {linkLabel}
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1160" data-mp="2gp2obodt15ho" />
          </SmartLink>
        </div>
      </div>
    </section>;
}